import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import vdatas from "../../../data/DataVisual";
import { Link } from "react-router-dom";

export const Projectme2 = () => {
  const [expanded, setExpanded] = useState(true);

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <div className="max-w-screen-xl mx-auto xs:px-4 sm:px-8 xs:pb-10">
        <div className="border-b mb-5 flex justify-between text-sm">
          <div className="text-indigo-600 flex items-center pb-2 pr-2 border-b-2 border-[#09bef0] uppercase">
            <span className="font-semibold inline-block text-white text-lg ml-2">
              Software Development
            </span>
          </div>
          <span
            className="text-sm text-gray-300 mt-2 mr-2 cursor-pointer"
            onClick={toggleExpansion}
          >
            {expanded ? "Expand" : "Collapse"}
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {vdatas.map((vdata, index) => (
            <div
              key={index}
              className={`overflow-hidden flex flex-col bg-white ${
                expanded ? "hidden" : "transition-all duration-300 ease-in-out"
              }`}
            >
              <div className="overflow-hidden flex flex-col bg-white">
                <div className="relative">
                  <img className="w-full" src={vdata.image} alt={vdata.title} />
                  <div className="hover:bg-transparent transition duration-300 absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25"></div>
                  <Link to={vdata.repo} target="_blank">
                    <div className="text-xs absolute top-0 right-0 bg-emerald-800 px-4 py-2 text-white mt-3 mr-3 hover:text-black hover:bg-emerald-700 transition duration-500 ease-in-out">
                      Source
                    </div>
                  </Link>
                </div>
                <div className="px-6 py-4 mb-auto">
                  <Link to={vdata.live} target="_blank">
                    <span className="font-semibold hover:text-[#09bef0]">{vdata.title}</span>
                  </Link>
                  <p className="text-gray-500 text-sm leading-5 h-20 overflow-hidden">
                    {vdata.description}
                  </p>
                </div>
                <div className="px-6 py-3 flex flex-row items-center justify-between bg-gray-300">
                  <span className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                    <span className="ml-1">{vdata.date}</span>
                  </span>

                  <span className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                    <FontAwesomeIcon className="text-gray-600" icon={faGear} />
                    <span className="ml-1">{vdata.technologies}</span>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
